import { Control, useFormContext } from "react-hook-form";

import { getPropertyOptions } from "#modules/similarPart/domain/getPropertyOptions";
import { NativeSelectInputController } from "#shared/view/designSystem/inputs/NativeSelectInputController";
import { FilterQuery } from "shared";

export type ValueType =
  | "materialGrade"
  | "number"
  | "size"
  | "tolerance"
  | "client"
  | "text"
  | "feature"
  | "percentage";

type Props = {
  expressionIndex: number;
  control: Control<FilterQuery>;
  hasDimensionsFilter: boolean;
};

export const FilterPropertyInputController = ({
  expressionIndex,
  control,
  hasDimensionsFilter,
}: Props) => {
  const { setValue } = useFormContext<FilterQuery>();
  const propertyOptions = getPropertyOptions({ hasDimensionsFilter });

  return (
    <NativeSelectInputController
      name={`filterGroup.expressions.${expressionIndex}.property`}
      control={control}
      data={propertyOptions}
      onChange={(value) => {
        setValue(`filterGroup.expressions.${expressionIndex}.value`, "");
        setValue(
          `filterGroup.expressions.${expressionIndex}.operator`,
          propertyOptions.find((option) => option.value === value)?.operators[0] || "EQUAL",
        );
      }}
    />
  );
};
